module.exports = __webpack_public_path__ + "img/logicmax-NB.b74eda06.gif";